import { api } from '../../DefaultService';
import { IPaginationParams } from '../../types';
import {
  ISchoolMonitoringEventSimpleProps,
  ISchoolMonitoringFilterProps
} from './types';

export const SCHOOL_MONITORING_EVENT_ENDPOINT = 'v1/events/schoolMonitoring';

const formatApiError = (error: any): Error => {
  return new Error(
    error?.response?.data?.message || 'Ocorreu um erro inesperado. Tente novamente.'
  );
};

export const getAllSchoolMonitoringEventByLicenseAsync = async (
  pagination?: IPaginationParams,
  filter?: ISchoolMonitoringFilterProps
): Promise<ISchoolMonitoringEventSimpleProps[]> => {
  try {
    const response = await api.get(`${SCHOOL_MONITORING_EVENT_ENDPOINT}/getAllByLicense`, {
      params: { 
        ...pagination, 
        ...filter 
      },
    });
    return response.data;
  } catch (error) {
    throw formatApiError(error);
  }
};

export const getAllSchoolMonitoringEventCountByLicenseAsync = async (
  filter?: ISchoolMonitoringFilterProps
): Promise<number> => {
  try {
    const response = await api.get(`${SCHOOL_MONITORING_EVENT_ENDPOINT}/getAllByLicense/count`, {
      params: { ...filter },
    });
    return response.data;
  } catch (error) {
    throw formatApiError(error);
  }
};

export const deleteSchoolMonitoringEventAsync = async (
  id: number
): Promise<void> => {
  try {
    await api.delete(`${SCHOOL_MONITORING_EVENT_ENDPOINT}/${id}`);
  } catch (error) {
    throw formatApiError(error);
  }
};
